export default __webpack_public_path__ + "./ico-completed-courses-on.081bdb47a434252abfa0f865c056daa7.png";